import React, { useState ,useEffect } from 'react';
import { Grid , Button, ListItemText , ListItem, Paper , Divider} from '@material-ui/core';
import { FixedSizeList } from 'react-window';
import InfiniteLoader from 'react-window-infinite-loader';
import { makeStyles } from '@material-ui/core/styles';
import Checkbox from "@material-ui/core/Checkbox";
import FormControl from "@material-ui/core/FormControl";
import FormGroup from "@material-ui/core/FormGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";

import { reqCustomers,reqOrderUpdate} from './api';
import { useNotify} from 'react-admin';

const PER_PAGE = 500;
const MainBoard = ({ }) => {
    
    const [ items, setItems ] = useState([]);
    const [ itemCount, setItemCount ] = useState(0);
    const [ loading, setLoading ] = useState(false);
    const [ error, setError ] = useState();
    const [ params , setParams] = useState(true);
    const notify = useNotify();
    // 체크박스 values
    const [checked, setChecked] = React.useState({
        checkA: true,
        checkB: true , 
        checkC: true , 
        checkD : true
    });
    let arrTyr = [];

  const isItemLoaded = index => {
    return items.length === itemCount || index < items.length;
  }

  // 수정 input 입력에 따른 변경 Body 설정
  const handleInputChange = (event) => {
    let arrIm = arrTyr ; 
    let toPush = {
        id : event.target.id ,
        orderQty : event.target.value
    }

    let existId = arrIm.map((toPush) => toPush.id );
    if (!existId.includes(toPush.id))  {
        arrIm.push(toPush);
    }
    else {
        arrIm = arrIm.map(
            item => item.id === event.target.id
              ? { ...item, orderQty : event.target.value } // 새 객체를 만들어서 기존의 값과 전달받은 data 을 덮어씀
              : item // 새로 추가
          )
    }
    //setParams(arrIm);
    arrTyr = arrIm
  }

  // 수정사항 저장 handle
  const handleSave = async () => {
     // console.log(arrTyr)
     try {
        setLoading(true);
        
        const { data } = await reqOrderUpdate( arrTyr);
        notify('저장이 완료 되었습니다', 'info');
        loadMore();
       setLoading(false);
      } catch (err) {
        setError(err);
        setLoading(false);
        notify(err.message, 'error');
        // LATER: server logging
        console.error(err)
      }  /* */
  }

  const loadMore = async (startIndex, stopIndex) => {
    
    if (loading || startIndex >= itemCount) return;
    
    try {
      setLoading(true);
      
      // load next page
      const nextPage = Math.ceil(items.length / PER_PAGE) + 1;
      let check = [];
      if (checked.checkA) check.push('0');
      if (checked.checkB) check.push('1');
      if (checked.checkC) check.push('2');
      if (checked.checkD) check.push('3');
      const { total, data } = await reqCustomers(1, PER_PAGE , check);
      
      // update items, itemCount
      //setItems(items.concat(data));
      setItems(data);
      setItemCount(data.length);
      
      setLoading(false);
    } catch (err) {
      console.error(err);
      setLoading(false);
      setError(err);
    }
  }

  useEffect(() => {
     // initialize 
     setItems([]);
     setItemCount(1);
     loadMore();
  }, [checked]);

  const handleCheckChangeA = event => {
    console.log('A')
    setChecked({ ...checked, [event.target.name]: event.target.checked });
    
  };

  const handleCheckChangeB = event => {
    console.log('B')
    setChecked({ ...checked, [event.target.name]: event.target.checked });
    
  };

  const handleCheckChangeC = event => {
    console.log('C')
    setChecked({ ...checked, [event.target.name]: event.target.checked });
    
  };

  const handleCheckChangeD = event => {
    
    setChecked({ ...checked, [event.target.name]: event.target.checked });
    
  };
  const useStyles = makeStyles((theme) => ({
    root: {
      flexGrow: 1,
    },
    paper: {
      padding: theme.spacing(0),
      textAlign: 'center',
      color: theme.palette.text.secondary,
    },
  }));
  const classes = useStyles();
    return (
    <div style={{paddingBottom:'30px' , paddingTop : '10px'}}>
        <div style={{paddingBottom:'30px'}}>
          <div>주문 확인</div>
        <Grid container spacing={1}>
            <Grid item xs={10}>
            <FormControl component="fieldset">
                <FormGroup row>
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={checked.checkA}
                            onChange={handleCheckChangeA}
                            name="checkA"
                        />
                        }
                        label="예약주문확인전"
                    />
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={checked.checkB}
                            onChange={handleCheckChangeB}
                            name="checkB"
                        />
                        }
                        label="확정주문확인전"
                    />
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={checked.checkC}
                            onChange={handleCheckChangeC}
                            name="checkC"
                        />
                        }
                        label="조리시작전"
                    />
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={checked.checkD}
                            onChange={handleCheckChangeD}
                            name="checkD"
                        />
                        }
                        label="조리시작"
                    />
                </FormGroup>
                
            </FormControl>
            </Grid>
            <Grid item xs={2}>
                <Button variant='outlined' onClick={handleSave}>수정내용저장</Button>
            </Grid>
        </Grid>
        </div>
         <Grid style={{paddingLeft:'16px'}} container spacing={0}>
            <Grid alignContent='center' item ><Paper elevation={0} style={{width:'90px'}} className={classes.paper}>ID</Paper></Grid>
            <Grid alignContent='center' item ><Paper elevation={0} style={{width:'90px'}} className={classes.paper}>날짜</Paper></Grid>
            <Grid alignContent='center' item ><Paper elevation={0} style={{width:'255px'}} className={classes.paper}>브랜드명</Paper></Grid>
            <Grid alignContent='center' item ><Paper elevation={0} style={{width:'185px'}} className={classes.paper}>상태</Paper></Grid>
            <Grid alignContent='center' item ><Paper elevation={0} style={{width:'200px'}} className={classes.paper}>연락처</Paper></Grid>
            <Grid alignContent='center' item ><Paper elevation={0} style={{width:'255px'}} className={classes.paper}>메뉴</Paper></Grid>
            <Grid alignContent='center' item ><Paper elevation={0} style={{width:'138px'}} className={classes.paper}>픽업시간</Paper></Grid>
            <Grid alignContent='center' item ><Paper elevation={0} style={{width:'230px'}} className={classes.paper}>업체명</Paper></Grid>
            <Grid alignContent='center' item ><Paper elevation={0} style={{width:'155px'}} className={classes.paper}>최소수량</Paper></Grid>
            <Grid alignContent='center' item ><Paper elevation={0} style={{width:'100px'}} className={classes.paper}>신청수량</Paper></Grid>
            <Grid alignContent='center' item ><Paper elevation={0} style={{width:'80px'}} className={classes.paper}>주문수량</Paper></Grid>
            
        </Grid> 
        
        <InfiniteLoader
            isItemLoaded={isItemLoaded}
            loadMoreItems={loadMore}
            itemCount={itemCount}
      >
        {({ onItemsRendered, ref }) => (
          <FixedSizeList
            height={350}
            width={'100%'}
            itemSize={46}
            itemCount={itemCount}
            onItemsRendered={onItemsRendered}
            ref={ref}
          >
            {({ index, style }) => 
            <ListItem
              button
              style={style}
              key={index}
            >
                <ListItemText style={{width:'1%', textAlign :'center'}}
                    primary={isItemLoaded(index) ? items[index].id : ''} />
                <ListItemText style={{width:'1%' , textAlign :'center'}}
                    primary={isItemLoaded(index) ? items[index].date : ''} />
                <ListItemText style={{width:'10%', textAlign :'center'}}
                    primary={isItemLoaded(index) ? items[index].supplierName : ''} />
                <ListItemText style={{width:'7%' , textAlign :'center'}}
                    primary={isItemLoaded(index) ? items[index].status : ''} />
                <ListItemText style={{width:'7%', textAlign :'center'}}
                    primary={isItemLoaded(index) ? items[index].telNo : ''} />
                <ListItemText style={{width:'10%', textAlign :'center'}}
                    primary={isItemLoaded(index) ? items[index].menuName : ''} />
                <ListItemText style={{width:'3%', textAlign :'center'}}
                    primary={isItemLoaded(index) ? items[index].pickupTime : ''} />
                <ListItemText style={{width:'10%', textAlign :'center'}}
                    primary={isItemLoaded(index) ? items[index].customerName : ''} />
                <ListItemText style={{width:'3%', textAlign :'center'}}
                    primary={isItemLoaded(index) ? items[index].minQty : ''} />
                <ListItemText style={{width:'3%', textAlign :'center'}}
                    primary={isItemLoaded(index) ? items[index].userQty : ''} />
                 <input style={{width:'3%'}} id={isItemLoaded(index) ? items[index].id : '0'} type='text' defaultValue={isItemLoaded(index) ? items[index].orderQty : ''} 
                    onChange={handleInputChange}
                />
            </ListItem>
            
            }
            
          </FixedSizeList>
        )}
      </InfiniteLoader>
    </div>

    );
}
export default MainBoard;